import dynamic from "next/dynamic";
import { Container, Col, Row } from "react-bootstrap";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import styleSub from "../../styles/Subpage.module.scss";
import { useTranslation } from "next-i18next";
import logo from "../../public/logo.svg";
import { useRouter } from "next/router";
import Image from "next/image";
import PageLayout from "../../components/layout/PageLayout";
import { staticPath } from "../../utils";
import { getFooterData } from "../../utils/apiHelpers";

const Seo = dynamic(() => import("../../components/seo/Seo"), {
  ssr: false,
});
const SubTitle = dynamic(() => import("../../components/title/SubTitle"), {
  ssr: false,
});
const Error = dynamic(() => import("../../components/error/Error"), {
  ssr: false,
});

const PageDetail = ({ data, navbar, footer, navbarData, navbarFooterData }) => {
  const { t } = useTranslation();
  const { asPath } = useRouter();

  return (
    <PageLayout
      navbarData={navbarData}
      navbar={navbar}
      footer={footer}
      navbarFooterData={navbarFooterData}
    >
      <SubTitle
        TitleText={data.title}
        pageName={data.title}
        mainPageHref={"/blog"}
        mainPageName={t("home:blog")}
        className="section_header_page_blog"
        mainPageRoute="/blog"
      />
      <Seo
        title={`${data.title} | İşNet`}
        keywords={`${data.title}`}
        description={`${data.title} başlıklı yazımızı okumak için tıklayın. İşNet'in Dijitalleşme Çözümleri ve e-Dönüşüm hizmetleri hakkında bilgi almak için form doldurun.`}
        url={asPath}
        img={
          data.picture
            ? data?.picture?.type + ";base64," + data?.picture?.src
            : "/logo.svg"
        }
      />
      <div className={styleSub.sub_page}>
        <Container>
          <Row gap={3}>
            <Col xs={12} md={5}>
              <div
                className={styleSub.sub_img}
                style={{ marginTop: "10px", borderRadius: "0" }}
              >
                <Image
                  width={545}
                  height={333}
                  src={process.env.IMAGE_URL + data.pictureUrl}
                  alt={data.title}
                />
              </div>
            </Col>
            <Col xs={12} md={7}>
              <div
                className={styleSub.sub_paragraph}
                dangerouslySetInnerHTML={{ __html: data.description }}
              ></div>
            </Col>
          </Row>
        </Container>
      </div>
    </PageLayout>
  );
};

export async function getServerSideProps(context) {
  let { id } = context.query;

  const [data, navbarData, navbarFooterData, footerData] = await Promise.all([
    fetch(`${process.env.ISNETURL}/blog/bizdenhaberler/${id}`).then((res) =>
      res.json()
    ),
    fetch(`${process.env.ISNETURL}/menu`).then((res) => res.json()),
    fetch(`${process.env.ISNETURL}/menu/footermenu`).then((res) => res.json()),
    getFooterData(),
  ]);

  const navbarFilter =
    navbarData && navbarData?.filter((item) => item.isDeleted === false);

  let navbar, footer;
  if (navbarFilter || footerData) {
    const nav = staticPath(navbarFilter);
    navbar = nav;
    footer = footerData;
  }

  context.res.setHeader(
    "Cache-Control",
    "public, s-maxage=10, stale-while-revalidate=59"
  );

  return {
    props: {
      ...(await serverSideTranslations(context.locale, ["home"])),
      data,
      navbar,
      footer,
      navbarData,
      navbarFooterData,
    },
  };
}

export default PageDetail;
